export default "__VITE_ASSET__VKMhOkBL__"